import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button } from 'reactstrap';
import { useUser } from 'context';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import { getSeguroPraxisMedica } from 'features/paperwork/seguroAPI';

export default function SeguroMalaPraxis() {
  const { getMatricula } = useUser();

  const [showAlert, message, alert] = useAlert(false, '');

  const [isLoading, setIsLoading] = useState(false);
  const [hasInsurance, setHasInsurance] = useState(false);
  const [certificate, setCertificate] = useState('');

  useEffect(() => {
    const matricula = getMatricula();
    if (!matricula) {
      console.error('No se pudo obtener la matrícula del usuario');
      return;
    }

    setIsLoading(true);

    getSeguroPraxisMedica(parseInt(matricula))
      .then(url => {
        if (!url) {
          setHasInsurance(false);
          return;
        }

        setCertificate(url);
        setHasInsurance(true);
      })
      .catch(err => {
        console.error(err);
        alert(true,
          err?.message ??
          'Ocurrió un error inesperado al obtener el certificado de praxis médica.',
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const showCertificate = () => {
    window.open(certificate, '_blank');
  };

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col style={{ fontSize: '1.5rem', marginTop: '10px' }}>Seguro de Praxis Médica</Col>
              </Row>
            </CardHeader>
            <CardBody>
              <div className="text-center">
                <p>
                  En mi carácter de profesional matriculado, declaro mi voluntad de adherirme al SEGURO DE
                  PRAXIS PROFESIONAL y al SEGURO DE ACCIDENTES PERSONALES contratados
                  colectivamente por el Colegio. En virtud de ello, me obligo a denunciar el acaecimiento de todo
                  evento susceptible de generar responsabilidad profesional/accidentes personales dentro del
                  plazo estricto de setenta y dos (72) horas de producido el hecho.
                  Asimismo, DECLARO BAJO JURAMENTO conocer y aceptar las condiciones generales y
                  particulares de la cobertura, así como las obligaciones puestas a mi cargo por la Ley Nacional
                  de Seguros N° 17.418 y las resoluciones dictadas por el Colegio en esta materia.
                  Acepto de forma expresa y voluntaria que el incumplimiento en tiempo y forma de mis
                  obligaciones colegiales (pago de matrícula, intereses, multas y/o cualquier otra deuda por el
                  concepto que fuere) facultará al Colegio a proceder con mi baja inmediata de los seguros,
                  perdiendo así la cobertura sin necesidad de interpelación ni notificación previa alguna. A tal
                  efecto, para aquellos casos en que la matrícula se abone mediante pagos parciales o cuotas,
                  presto conformidad para que la baja de estos beneficios opere de manera automática al
                  registrarse una mora equivalente a dos (2) meses adeudados.
                  Comprendo y acepto que, hasta tanto no regularice mi situación y cumpla con los requisitos
                  dispuestos, careceré de la cobertura de este beneficio voluntario. Una vez cancelada la deuda,
                  y en caso de requerir el restablecimiento de los seguros, me comprometo a solicitar
                  expresamente mi reincorporación mediante la suscripción de un nuevo formulario habilitante.
                </p>
                {
                  !isLoading
                    ? hasInsurance
                      ? <Button
                          className="my-4"
                          color="primary"
                          type="button"
                          onClick={ showCertificate }
                          disabled={ isLoading }
                        >
                          Ver Cobertura
                        </Button>
                      : <h3>Sin Cobertura</h3>
                    : <Button className="my-4" color="primary" type="button" disabled>Cargando...</Button>
                }
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
